module.exports = __webpack_public_path__ + "img/startConfigurationSolitair@2x.d5aba38.png";